import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {
  mediaDesktopAndUp,
  mediaExtraLargeScreens,
} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const ProductTileAdditionalStreamTitle: FC<{
  additionalStreamTitle: string;
  gridColumns?: number;
}> = ({additionalStreamTitle, gridColumns = 2}) => {
  if (gridColumns) {
    return <Title gridColumns={gridColumns}>{additionalStreamTitle}</Title>;
  }
  return <FluidTitle>{additionalStreamTitle}</FluidTitle>;
};

const createGridColumnsCSS = ({gridColumns}: {gridColumns: number}) => css`
  grid-column: 1 / ${gridColumns + 1};
`;

const BaseTitle = styled.h4`
  color: ${COLORS.Grey1};
  margin: 0.81rem 0 2.31rem;
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.light};
  text-align: center;
`;

const Title = styled(BaseTitle)<{gridColumns: number}>`
  ${createGridColumnsCSS}
  ${BaseTitle}
`;

const FluidTitle = styled(BaseTitle)`
  ${createGridColumnsCSS({gridColumns: 2})}
  @media ${mediaDesktopAndUp} {
    ${createGridColumnsCSS({gridColumns: 3})}
  }
  @media ${mediaExtraLargeScreens} {
    ${createGridColumnsCSS({gridColumns: 4})}
  }
`;
